import useDefaultV2CustomDomain from "@agent-ui/features/page-settings/useDefaultCustomDomain";
import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";

const usePublishedSiteUrls = ({
  pageRoutesToUseForPreview,
}: {
  pageRoutesToUseForPreview: string[];
}) => {
  const { project } = useCurrentProjectContext();

  const defaultCustomDomain = useDefaultV2CustomDomain();

  const normalizeRoute = (route: string) => {
    const withLeadingSlash = route.startsWith("/") ? route : `/${route}`;
    return withLeadingSlash === "/" ? "" : withLeadingSlash;
  };

  // NOTE (Cole, 2025-07-14): This should never result in undefined for a published site
  const reploShopsUrls = pageRoutesToUseForPreview.map((pageRoute) => {
    const path = normalizeRoute(pageRoute);
    return project?.shopDomainPrefix
      ? `https://${project.shopDomainPrefix}.reploshops.com${path}`
      : undefined;
  });

  const publishedSiteUrls = pageRoutesToUseForPreview.map(
    (pageRoute, index) => {
      const path = normalizeRoute(pageRoute);
      return defaultCustomDomain?.value
        ? `https://${defaultCustomDomain.value}${path}`
        : reploShopsUrls[index];
    },
  );

  return publishedSiteUrls;
};

export default usePublishedSiteUrls;
